function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient1",
  x1: 135.34,
  y1: -249.16,
  x2: 135.34,
  y2: -428.42,
  gradientTransform: "matrix(1, 0, 0, -1, 0, -232)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#88d2e5"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8a4fcd",
  stopOpacity: 0.99
}));
var _ref3 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-onboard2",
  cx: -1752.26,
  cy: 1804.37,
  r: 0.9,
  gradientTransform: "matrix(26.4, 0, 0, -26.4, 46450.42, 47755.6)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#09f"
}), React.createElement("stop", {
  offset: 0.6,
  stopColor: "#a033ff"
}), React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ff5280"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ff7061"
}));
var _ref4 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-onboard-2",
  cx: -1907.39,
  cy: 1803.51,
  r: 0.9,
  gradientTransform: "matrix(0, -24.4, -22.7, 0, 41021.46, -46467.6)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fd5"
}), React.createElement("stop", {
  offset: 0.1,
  stopColor: "#fd5"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#ff543e"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#c837ab"
}));
var _ref5 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-onboard-3",
  cx: -1598.37,
  cy: 1914.65,
  r: 0.9,
  gradientTransform: "matrix(2.14, 10.69, 44.09, -8.83, -80925.95, 34045.99)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#3771c8"
}), React.createElement("stop", {
  offset: 0.13,
  stopColor: "#3771c8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#60f",
  stopOpacity: 0
}));
var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 119.88,
  y1: -415.17,
  x2: 119.88,
  y2: -390.89,
  gradientTransform: "matrix(1, 0, 0, -1, 0, -232)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0062e0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#19afff"
}));
var _ref7 = /*#__PURE__*/React.createElement("style", null, "\n        .facebook-onboard2-shadow {\n            filter: drop-shadow(2px 4px 6px #00000022);\n        }\n    ");
var SvgFacebookOnboard3 = function SvgFacebookOnboard3(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 264 209",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("defs", null, _ref2, React.createElement("clipPath", {
    id: "clip-path-onboard2"
  }, React.createElement("rect", {
    x: 187.24,
    y: 98.72,
    width: 21.56,
    height: 21.56,
    style: {
      fill: "none"
    }
  })), _ref3, _ref4, _ref5, React.createElement("clipPath", {
    id: "clip-path-onboard2-2"
  }, React.createElement("rect", {
    x: 107.3,
    y: 158.89,
    width: 25.15,
    height: 25.15,
    style: {
      fill: "none"
    }
  })), _ref6), _ref7, React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "front"
  }, React.createElement("path", {
    d: "M135.34,200c52.83,0,95.66-43,95.66-96S188.17,8,135.34,8,39.67,51,39.67,104,82.5,200,135.34,200Zm-1.12-53.87a40.9,40.9,0,1,0-40.91-40.9A40.9,40.9,0,0,0,134.22,146.13Z",
    style: {
      fillOpacity: 0.4000000059604645,
      fillRule: "evenodd",
      fill: "url(#linear-gradient1)"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 38.79,
    cy: 70.56,
    r: 6.03,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 191,
    cy: 169.36,
    r: 10.73,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 128.04,
    cy: 26.4,
    r: 10.73,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 78.67,
    cy: 129.84,
    r: 10.73,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 219.61,
    cy: 129.79,
    r: 4.02,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 201.06,
    cy: 74.14,
    r: 4.02,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 63.6,
    cy: 150.13,
    r: 4.02,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 48.85,
    cy: 96.27,
    r: 8.05,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 190.56,
    cy: 51.12,
    r: 8.05,
    style: {
      fill: "#fff"
    }
  }), React.createElement("circle", {
    className: "facebook-onboard2-shadow",
    cx: 134.25,
    cy: 105.9,
    r: 21.56,
    style: {
      fill: "#fff"
    }
  }), React.createElement("rect", {
    width: 264,
    height: 209,
    style: {
      fill: "none"
    }
  }), React.createElement("g", {
    id: "b1aa435c-b240-435c-91fb-1b2570fb87bb"
  }, React.createElement("g", {
    id: "a40c8807-c089-44dd-a0ca-92880595fcee"
  }, React.createElement("path", {
    d: "M121,105.64a2.44,2.44,0,0,0,0,.27v0h0A1.69,1.69,0,0,1,121,105.64Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M130.25,105.88a1.09,1.09,0,0,1,0,.18v-.38C130.24,105.75,130.25,105.81,130.25,105.88Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M139.49,105.87v.19h0a4.62,4.62,0,0,1-9.24,0,.28.28,0,0,0,0-.09v-.29a4.63,4.63,0,0,1,9.25-.06h0v0h0Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M139.49,105.87v.19h0v-.36h0Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M148.74,105.86V106a.76.76,0,0,1,0,.15c0-.11,0-.21,0-.32s0-.22,0-.33a.66.66,0,0,1,0,.14h0v.17Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M121,105.87h0v0a2.44,2.44,0,0,1,0-.27A1.69,1.69,0,0,0,121,105.87Zm18.5,0v-.19h0v0h0a4.63,4.63,0,0,0-9.25.06v.38a4.63,4.63,0,0,0,9.25,0v-.19Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M148.73,105.87v.32h0a4.63,4.63,0,0,1-9.24-.07h0v-.44h0v-.06h0a9.25,9.25,0,0,0-18.49,0h0a1.69,1.69,0,0,0,0,.23,13.87,13.87,0,0,1,27.73-.66c0,.11,0,.22,0,.33h0Z",
    style: {
      fill: "#6fd4e7"
    }
  }), React.createElement("path", {
    d: "M139.49,105.62a4.63,4.63,0,0,0-9.25.06v0a4.63,4.63,0,0,0-9.25,0,9.25,9.25,0,0,1,18.5,0Z",
    style: {
      fill: "#2d2b4e"
    }
  }), React.createElement("path", {
    d: "M148.72,106.56a13.87,13.87,0,0,1-27.72-.11v0c0-.17,0-.33,0-.49h0a2.44,2.44,0,0,1,0-.27h0a4.63,4.63,0,0,1,9.25,0v.45a9.25,9.25,0,0,0,18.47.46Z",
    style: {
      fill: "#9854dc"
    }
  }), React.createElement("path", {
    d: "M121,106.41c0-.15,0-.29,0-.44v-.06C121,106.08,121,106.24,121,106.41Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M139.49,106v.08a4.62,4.62,0,0,1-9.24,0v-.38a4.62,4.62,0,0,1,9.24-.06h0v.07h0c0,.07,0,.14,0,.22A.15.15,0,0,0,139.49,106Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M148.73,106.19c0,.13,0,.25,0,.37a9.25,9.25,0,0,1-18.48-.46v0a4.63,4.63,0,0,0,9.25,0v.06h0a4.62,4.62,0,0,0,9.23.07Z",
    style: {
      fill: "#2d2b4e"
    }
  }), React.createElement("path", {
    d: "M139.49,105.9v.16a4.62,4.62,0,0,1-9.24,0v-.19h0v-.18a4.62,4.62,0,0,1,9.24-.06h0v0h0c0,.07,0,.13,0,.19A.08.08,0,0,0,139.49,105.9Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M148.74,105.86V106c0,.17,0,.35,0,.52,0-.12,0-.24,0-.37h0c0-.1,0-.21,0-.32s0-.21,0-.32h0c0-.11,0-.22,0-.33,0,.16,0,.31,0,.47v.18Z",
    style: {
      fill: "none"
    }
  })))), React.createElement("g", {
    id: "front1",
    className: "facebook-onboard2-shadow"
  }, React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-onboard2)"
    }
  }, React.createElement("path", {
    d: "M198,98.72a10.4,10.4,0,0,0-10.78,10.45,10.21,10.21,0,0,0,3.39,7.73.91.91,0,0,1,.29.62l.05,1.92a.93.93,0,0,0,.12.4.83.83,0,0,0,.29.3.79.79,0,0,0,.39.13.83.83,0,0,0,.41-.07l2.14-.94a.89.89,0,0,1,.58-.05,11.75,11.75,0,0,0,3.12.42,10.46,10.46,0,1,0,0-20.91Z",
    style: {
      fill: "url(#radial-gradient-onboard2)"
    }
  }), React.createElement("path", {
    d: "M191.55,112.23l3.16-5a1.65,1.65,0,0,1,1.08-.73,1.63,1.63,0,0,1,.66,0,1.67,1.67,0,0,1,.6.29l2.52,1.88a.65.65,0,0,0,.78,0l3.4-2.58a.52.52,0,0,1,.75.68l-3.17,5a1.59,1.59,0,0,1-1.08.73,1.47,1.47,0,0,1-.66,0,1.5,1.5,0,0,1-.6-.28l-2.52-1.89a.67.67,0,0,0-.39-.12.61.61,0,0,0-.39.13l-3.4,2.58a.51.51,0,0,1-.74-.68Z",
    style: {
      fill: "#fff"
    }
  }))), React.createElement("g", {
    id: "front2",
    className: "facebook-onboard2-shadow"
  }, React.createElement("path", {
    d: "M88.9,47.69c-4.62,0-6,0-6.23,0a5.49,5.49,0,0,0-2.18.54,4.53,4.53,0,0,0-1.27.93,4.75,4.75,0,0,0-1.28,2.69,19.36,19.36,0,0,0-.11,3.27v3.59c0,4.62,0,6,0,6.23a5.5,5.5,0,0,0,.53,2.13,4.63,4.63,0,0,0,3,2.47,7.59,7.59,0,0,0,1.6.21l5.86,0h5.86a8.16,8.16,0,0,0,1.66-.22,4.62,4.62,0,0,0,3-2.47,5.54,5.54,0,0,0,.52-2.1c0-.19,0-3.23,0-6.26s0-6.07,0-6.26a5.36,5.36,0,0,0-.53-2.11,4.41,4.41,0,0,0-1-1.3,4.79,4.79,0,0,0-2.69-1.28,20.09,20.09,0,0,0-3.26-.1Z",
    style: {
      fill: "url(#radial-gradient-onboard-2)"
    }
  }), React.createElement("path", {
    d: "M88.9,47.69c-4.62,0-6,0-6.23,0a5.49,5.49,0,0,0-2.18.54,4.53,4.53,0,0,0-1.27.93,4.75,4.75,0,0,0-1.28,2.69,19.36,19.36,0,0,0-.11,3.27v3.59c0,4.62,0,6,0,6.23a5.5,5.5,0,0,0,.53,2.13,4.63,4.63,0,0,0,3,2.47,7.59,7.59,0,0,0,1.6.21l5.86,0h5.86a8.16,8.16,0,0,0,1.66-.22,4.62,4.62,0,0,0,3-2.47,5.54,5.54,0,0,0,.52-2.1c0-.19,0-3.23,0-6.26s0-6.07,0-6.26a5.36,5.36,0,0,0-.53-2.11,4.41,4.41,0,0,0-1-1.3,4.79,4.79,0,0,0-2.69-1.28,20.09,20.09,0,0,0-3.26-.1Z",
    style: {
      fill: "url(#radial-gradient-onboard-3)"
    }
  }), React.createElement("path", {
    d: "M88.89,50.58c-2.22,0-2.49,0-3.36.05a6.1,6.1,0,0,0-2,.38A4.07,4.07,0,0,0,82.1,52a4,4,0,0,0-.95,1.45,5.81,5.81,0,0,0-.37,2c0,.87,0,1.15,0,3.37s0,2.49,0,3.36a6.13,6.13,0,0,0,.37,2,4,4,0,0,0,.95,1.44,3.82,3.82,0,0,0,1.44.94,5.84,5.84,0,0,0,2,.38c.88,0,1.15,0,3.37,0s2.5,0,3.37,0a5.78,5.78,0,0,0,2-.38,3.85,3.85,0,0,0,1.45-.94,4.07,4.07,0,0,0,.94-1.44,6.1,6.1,0,0,0,.38-2c0-.87,0-1.15,0-3.36s0-2.5,0-3.37a6,6,0,0,0-.38-2A4.14,4.14,0,0,0,94.24,51a6.09,6.09,0,0,0-2-.38c-.88,0-1.15-.05-3.37-.05Zm-.73,1.47h.73c2.18,0,2.44,0,3.3.05a4.69,4.69,0,0,1,1.52.28,2.69,2.69,0,0,1,1.55,1.55,4.69,4.69,0,0,1,.28,1.52c0,.86,0,1.12,0,3.3s0,2.43,0,3.29a4.69,4.69,0,0,1-.28,1.52,2.69,2.69,0,0,1-1.55,1.55,4.69,4.69,0,0,1-1.52.28c-.86,0-1.12,0-3.3,0s-2.44,0-3.3,0a4.62,4.62,0,0,1-1.51-.28,2.59,2.59,0,0,1-.94-.61,2.43,2.43,0,0,1-.61-.94A4.2,4.2,0,0,1,82.25,62c0-.86,0-1.12,0-3.3s0-2.43,0-3.3a4.18,4.18,0,0,1,.28-1.51,2.43,2.43,0,0,1,.61-.94,2.47,2.47,0,0,1,.94-.61,4.36,4.36,0,0,1,1.51-.28c.76,0,1-.05,2.57-.05Zm5.09,1.36a1,1,0,1,0,1,1,1,1,0,0,0-1-1Zm-4.36,1.14a4.2,4.2,0,1,0,4.19,4.2,4.2,4.2,0,0,0-4.19-4.2Zm0,1.48a2.72,2.72,0,1,1-2.72,2.72A2.72,2.72,0,0,1,88.89,56Z",
    style: {
      fill: "#fff"
    }
  })), React.createElement("g", {
    id: "front3",
    className: "facebook-onboard2-shadow"
  }, React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-onboard2-2)"
    }
  }, React.createElement("path", {
    d: "M117.8,183.92a12.58,12.58,0,1,1,4.15,0l-.69-.57H118.5Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), React.createElement("path", {
    d: "M124.78,175l.57-3.52H122V169c0-1,.37-1.76,1.88-1.76h1.64v-3.21a19.94,19.94,0,0,0-2.77-.25,4.55,4.55,0,0,0-4.9,4.9v2.77h-3.15V175h3.15v8.87a12.06,12.06,0,0,0,2.07.18,12.26,12.26,0,0,0,2.08-.18V175Z",
    style: {
      fill: "#fff"
    }
  })))));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebookOnboard3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FacebookOnboard3.2ce2b3d1.svg";
export { ForwardRef as ReactComponent };